<template>
  <div class="seomain">
    <st-header
      :title="formData.id ? '编辑收款单' : '添加收款单'"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
      <st-form ref="form">
        <!-- <div class="st-form-title">基本信息</div> -->
        <div class="st-form-group">

          <van-cell-group inset>
						<st-form-item key="code" label="收款单号" prop="code" :required="true" disabled>
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.code"
						    name="收款单号"
						    label=""
						    placeholder="请填写收款单号"
						  />
						</st-form-item>
						
            <st-form-item key="order_code" label="销售单号" prop="order_code">
              <st-select
                v-model="formData.order_code"
								:defText="formData.order_code"
                name="销售单号"
                placeholder="请选择销售单号"
                :options="$option['getSalesOrder']"
								:clearable="true"
								val-field="ordercode"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="rma_code" label="供应商售后单号" prop="rma_code">
              <st-select
                v-model="formData.rma_code"
								:defText="formData.rma_code"
                name="供应商售后单号"
                placeholder="请选择供应商售后单号"
                :options="$option['getPurOrderReturn']"
								:clearable="true"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="customer_id" label="客户" prop="customer_id">
						  <st-select
						    v-model="formData.customer_id"
								:defText="formData.customer_name"
						    name="客户"
						    placeholder="请选择客户"
						    :options="$option['getCustomer']"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="company_id" label="收款单位" prop="company_id">
						  <st-select
						    v-model="formData.company_id"
								:defText="formData.company_name"
						    name="收款单位"
						    placeholder="请选择收款单位"
						    :options="$option['getCompanyList']"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="corporation_id" label="收款账户" prop="corporation_id">
						  <st-select
						    v-model="formData.corporation_id"
								:defText="formData.corporation_name"
						    name="收款账户"
						    placeholder="请选择收款账户"
						    :options="$option['getCorporation']"
						  >
						  </st-select>
						</st-form-item>

						<st-form-item key="predicttime" label="应收时间" prop="predicttime" :required="true">
							<st-date
								v-model="formData.predicttime"
								name="应收时间"
								placeholder="请选择应收时间"
							></st-date>
						</st-form-item>
						
						<st-form-item key="payment_account" label="收款账号" prop="payment_account" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.payment_account"
						    name="收款账号"
						    label=""
						    placeholder="请填写收款账号"
						  />
						</st-form-item>
						
						<st-form-item key="type" label="收款方式" prop="type">
						  <st-select
						    v-model="formData.type"
								:defText="formData.type_text"
						    name="收款方式"
						    placeholder="请选择收款方式"
						    :options="$option['getModelConf']('incomeorder','type')"
								:filterable="false"
								:clearable="true"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="currency" label="币种" prop="currency" :required="true">
						  <st-select
						    v-model="formData.currency"
						    name="币种"
						    placeholder="请选择币种"
						    :options="$option['getCurrency']"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="amount" label="收款金额" prop="amount" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.amount"
						    name="收款金额"
						    label=""
						    placeholder="请填写收款金额"
						  />
						</st-form-item>

            <st-form-item key="content" label="收款摘要" prop="content">
							<van-field
								class="st-form-item-input"
								v-model="formData.content"
								name="收款摘要"
								label=""
								placeholder="请填写收款摘要"
							/>
            </st-form-item>
          </van-cell-group>
        </div>
        
        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary"  @click="onSubmit">
            提交
          </van-button>
        </div>
      </st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import StHeader from "@/components/layout/Header.vue";
import StForm from "@/components/form.vue";
import StFormItem from "@/components/formItem.vue";
import formConf from "./conf/form.js";

export default {
  name: 'stSalesAdd',
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate
  },
  props: {},
  data() {
    return {
      formRule: {},
      formData: {
				currency: 'CNY',
				exchange_rate: 1,
				amount: 0,
      }, 
      loading: false,
      actField: '',
      actOptions: [],
			conf: formConf,
    };
  },
  watch: {},
	computed: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
  mounted() {},

  methods: {
    init() {
			let id = parseInt(this.$route.params['id']);
			this.formData.id = isNaN(id) ? 0 : id;
			this.getUpdateData();
		},
		// 获取编辑需要显示的数据
		getUpdateData() {
			if (this.formData.id) {
				this.$post(`${this.$api.stIncomeOrderEditInfo}`, {id: this.formData.id}).then((res) => {
					let data = res.data;
					this.formData = data;
				}).catch((err) => {
					window.history.go(-1);
					console.log('incomeorder/edit', err);
				});
			} else {
				this.$post(`${this.$api.stIncomeOrderGeneCode}`, {}).then((res) => {
					this.$set(this.formData, ['code'], res.data)
				});
			}
		},

    // 提交表单
    onSubmit() {
     this.$refs.form.validater.valid((isValid, lastError) => {
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastError);
        }
      });
			
      let formData = JSON.parse(JSON.stringify(this.formData));
			if (this.formData.id) {
				this.updateData(formData);
			} else {
				this.addData(formData);
			}
      
    },
		
		addData(formData) {
			this.$post(this.$api.stIncomeOrderAdd, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '创建异常');
			  } else {
			    this.$toast.success("创建成功");
			    this.$router.replace(`/incomeorder/list`);
			  }
			});
		},
		updateData(formData) {
			this.$post(this.$api.stIncomeOrderEdit, formData).then((res) => {
			  if (res.code !== 1) {
			    this.$toast.fail(res.msg ? res.msg : '编辑异常');
			  } else {
			    this.$toast.success("编辑收款单成功");
			    this.$router.replace(`/incomeorder/list`);
			  }
			});
		},
  },
};
</script>

<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;
	form {
		overflow: hidden;
	}
	
  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);

    .st-van-btn-info {
      float: right;
    }
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
		padding-bottom: 16px;
		border-radius: 5px;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

  }

}

</style>
